import { render, staticRenderFns } from "./commonBottomNav.vue?vue&type=template&id=6bd1fefc&scoped=true&"
import script from "./commonBottomNav.vue?vue&type=script&lang=js&"
export * from "./commonBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./commonBottomNav.vue?vue&type=style&index=0&id=6bd1fefc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1fefc",
  null
  
)

export default component.exports